import styles from "./Chart.module.scss";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { classNames } from "primereact/utils";
import { IChartViewModel } from "./models/chartViewModel";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface ILineGraphProps {
  className?: string;
  data: IChartViewModel | undefined;
}

export const BarChart = ({ className, data }: ILineGraphProps) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
    },
  };

  if (!data) {
    return;
  }
  return (
    <div className={classNames(styles.root, className)}>
      <Bar className={styles.root_graph} options={options} data={data} />
    </div>
  );
};
